import { render, staticRenderFns } from "./dashTipsModalV3.vue?vue&type=template&id=0b7923fa&scoped=true"
import script from "./dashTipsModalV3.vue?vue&type=script&lang=js"
export * from "./dashTipsModalV3.vue?vue&type=script&lang=js"
import style0 from "./dashTipsModalV3.vue?vue&type=style&index=0&id=0b7923fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7923fa",
  null
  
)

export default component.exports